module.exports = __webpack_public_path__ + "img/ai-icon.cbf65046.svg";